<template>
  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <h3 class="font-light m-b-xs">
            Search reference <span v-if="document" class="font-bold"> - {{document.title}}</span>
          </h3>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="hpanel">
        <div class="panel-body">
          <div class="text-center">
            <h2 class="m-b-xs" v-if="referenceFound === null">
              Search in Progress ...
            </h2>
            <h2 class="m-b-xs" v-else-if="referenceFound === true">
              Document found
            </h2>
            <h2 class="m-b-xs" v-else-if="referenceFound === false">
              Sorry, document not found!
            </h2>

            <h2 class="m-b-xs"></h2>
            <div class="m">
              <div class="full progress m-t-xs"  style="margin: 40px 0">
                <div class="progress-bar active " role="progressbar"
                     :class="{'progress-bar-striped': referenceFound === null, 'progress-bar-info': referenceFound !== false,
                     'progress-bar-danger': referenceFound === false}" aria-valuenow="100" aria-valuemin="0"
                     aria-valuemax="100" style="width: 100%">
                </div>
              </div>
            </div>
            <p v-if="referenceFound === null">
              We are looking for the document reference
            </p>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'DocumentReference',
  components: {},
  data () {
    return {
      documentId: null,
      document: null,
      referenceFound: null
    }
  },
  beforeMount () {
    this.documentId = this.$route.params.document_id

    let from = this.$route.query.from
    let keywords = this.$route.query.keywords
    let marketplace = this.$route.query.marketplace

    if (typeof from !== 'undefined' && typeof keywords !== 'undefined') {
      let routeName = this.$user.isBasic() ? 'SearchSimple' : 'Search'
      let routeData = this.$router.resolve({name: routeName, params: {query: keywords}, query: {marketplace: marketplace}})
      window.open(routeData.href, '_blank')
    }

    this.axios.get('/search/reference/' + this.documentId).then((response) => {
      this.document = response.data
      if (this.document !== null && Object.keys(this.document).length !== 0 && this.document.link !== null) {
        setTimeout(() => {
          window.location.href = this.document.link
        }, 3000)
        this.referenceFound = true
      } else {
        this.referenceFound = false
      }
    }).catch((error) => {
    })
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/search/DocumentReference.vue